import { LifeSkillsMonitoringResult } from 'api';

export const getLifeSkillsMonitoringResultName = (
  resultType: LifeSkillsMonitoringResult
): string => {
  const resultTypeNames: Record<LifeSkillsMonitoringResult, string> = {
    [LifeSkillsMonitoringResult.Standard]: 'Standard',
    [LifeSkillsMonitoringResult.NonStandard]: 'Non-Standard',
  };

  return resultTypeNames[resultType] ?? '-';
};
